<template>
  <div>
    <div class="d-flex flex-column align-center">
      <v-checkbox v-model="payload.口腔白斑" label="白斑"></v-checkbox>
      <v-checkbox v-model="payload.口腔齲齒" label="齲齒"></v-checkbox>
      <v-checkbox v-model="payload.口腔牙周病" label="牙周病"></v-checkbox>
      <v-checkbox
        v-model="payload.口腔無牙"
        label="全口無牙(智齒不計)"
      ></v-checkbox>
    </div>

    <v-btn block x-large class="mt-4 text-h6" color="success" @click="submit"
      >送出</v-btn
    >
    <v-btn block x-large class="mt-8 text-h6" color="error" @click="back"
      >取消</v-btn
    >
  </div>
</template>

<script>
import station from "@/mixins/station";
export default {
  mixins: [station],
  data: () => ({
    payload: {
      口腔白斑: null,
      口腔齲齒: null,
      口腔牙周病: null,
      口腔無牙: null,
    },
  }),
};
</script>

<style lang="scss" scoped>
::v-deep .v-input--selection-controls__input {
  .v-icon.v-icon {
    font-size: 2rem;
  }
}
::v-deep .v-label {
  font-size: 1.25rem;
}

::v-deep .v-input__control {
  width: 210px;
}
</style>
